import { Button, TextField, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { deleteProduct, getProducts } from "../../../../api/product";
import { getProductFamilies } from "../../../../api/productFamily";
import { getProductTypes } from "../../../../api/productType";
import { ROLES } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import FiltersCard from "../../../components/filters/Filter";
import Table, { buttonsStyle } from "../../../components/tables/table";
import ProductContent from "./ProductContent";
import { getProductMarcas } from "../../../../api/productMarca";

function getData(products) {
  let data = [];
  for (let i = 0; i < products.length; ++i) {
    const elem = {};
    const product = products[i];
    elem.referencia = product?.referencia;
    elem.descripcion = product?.descripcion;
    elem.marca = product?.marca?.nombre;
    elem.familia = product?.familia?.descripcion;
    elem.tipoProducto = product?.tipo_producto?.descripcion;
    elem.precio = product?.precio + " €";
    elem.id = product?.id;

    data = data.concat(elem);
  }
  return data;
}

const initialFilters = {
  familias: [],
  tipoProductos: [],
  marcas: [],
};

export default function ProductsPage() {
  const [data, setData] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [productFamilies, setProductFamilies] = useState([]);
  const [productTypes, setProductTypes] = useState([]);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [openProductInfoDialog, setOpenProductInfoDialog] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);

  const history = useHistory();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Editar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              history.push("/productos/" + cell + "/edit");
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {loggedUser?.role?.rango === ROLES.SUPER_ADMIN && (
          <>
            <Tooltip title="Eliminar">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedProduct(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    {
      dataField: "referencia",
      text: "Referencia",
      sort: true,
    },
    {
      dataField: "descripcion",
      text: "Descripción",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "marca",
      text: "Marca",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "familia",
      text: "Família",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "tipoProducto",
      text: "Tipo",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "precio",
      text: "Precio",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getProductMarcas(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setMarcas(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las marcas de productos.",
        });
      });
    getProductFamilies(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductFamilies(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las familias de productos.",
        });
      });
    getProductTypes(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductTypes(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los tipos de productos.",
        });
      });
    getProducts(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los productos.",
        });
      });
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.familias && filterOptions.familias.length > 0)
          filter =
            filter &&
            filterOptions.familias?.some((x) => x.id === item?.familia?.id);
        if (filterOptions.marcas && filterOptions.marcas.length > 0)
          filter =
            filter &&
            filterOptions.marcas?.some((x) => x.id === item?.marca?.id);
        if (
          filterOptions.tipoProductos &&
          filterOptions.tipoProductos.length > 0
        )
          filter =
            filter &&
            filterOptions.tipoProductos?.some(
              (x) => x.id === item?.tipo_producto?.id
            );
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <>
        <div className="d-sm-flex w-100">
          <Autocomplete
            className="w-100 mr-5"
            multiple
            id="autocomplete-marcas"
            filterSelectedOptions
            options={marcas}
            getOptionLabel={(option) => option?.nombre}
            value={filterOptions.marcas || []}
            onChange={(event, selected) => {
              setFilterOptions({
                ...filterOptions,
                marcas: selected,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Marcas"
              />
            )}
          />
          <Autocomplete
            className="w-100 mr-5"
            multiple
            id="autocomplete-families"
            filterSelectedOptions
            options={productFamilies}
            getOptionLabel={(option) => option?.descripcion}
            value={filterOptions.familias || []}
            onChange={(event, selected) => {
              setFilterOptions({
                ...filterOptions,
                familias: selected,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Familia"
              />
            )}
          />
          <Autocomplete
            className="w-100 mr-5"
            multiple
            id="autocomplete-tipos"
            filterSelectedOptions
            options={productTypes}
            getOptionLabel={(option) => option?.descripcion}
            value={filterOptions.tipoProductos || []}
            onChange={(event, selected) => {
              setFilterOptions({
                ...filterOptions,
                tipoProductos: selected,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Tipo de Producto"
              />
            )}
          />
        </div>
      </>
    );
  };

  return (
    <>
      <Card>
        <CardHeader headerClassName="px-0">
          <CardHeader
            title="Productos"
            sticky={false}
            headerClassName="d-flex justify-content-between w-100 py-3"
          >
            <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => history.push("/productos/edit")}
              >
                Nuevo producto
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <div className="w-100">
            <FiltersCard
              collapsable={false}
              filtersContent={renderFiltersContent}
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              handleClearFilters={handleClearFilters}
              handleSearch={handleSearch}
            />
          </div>
        </CardHeader>
        <CardBody>
          <Table
            data={getData(filteredData)}
            columns={columns}
            rowEvents={{
              onClick: (e, row, rowIndex) => {
                const product = data?.find((x) => x.id === row.id);
                setSelectedProduct(product);
                setOpenProductInfoDialog(true);
              },
            }}
          />
          <ConfirmDialog
            title={"¿Estás seguro de que quieres eliminar este producto?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteProduct(selectedProduct?.id, loggedUser?.accessToken)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "¡Eliminado!",
                      customMessage: "Producto eliminado con éxito.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar el producto.",
                  });
                });
            }}
          />
          <EntityInfoDialog
            title={"Producto: " + selectedProduct?.descripcion}
            open={openProductInfoDialog}
            setOpen={setOpenProductInfoDialog}
            content={<ProductContent product={selectedProduct} />}
          />
        </CardBody>
      </Card>
    </>
  );
}
